import type { NavigateOptions, To } from 'react-router-dom';

type AppRouter = {
  navigate: (to: To | number, options?: NavigateOptions) => void | Promise<void>;
};

type PathTo = {
  pathname?: string;
  search?: string;
  hash?: string;
  state?: unknown;
};

type Path = string | PathTo;

let appRouter: AppRouter | null = null;

export const setAppRouter = (router: { navigate: (...args: any[]) => any }) => {
  appRouter = router;
};

const toPathString = (path: PathTo): string =>
  `${path.pathname || ''}${path.search || ''}${path.hash || ''}`;

export const push = (path: Path, state?: unknown) => {
  if (!appRouter) {
    console.warn('Navigation called before router was initialized');
    return;
  }
  if (typeof path === 'string') {
    appRouter.navigate(path, { state });
  } else {
    appRouter.navigate(toPathString(path), { state: path.state ?? state });
  }
};

export const replace = (path: Path, state?: unknown) => {
  if (!appRouter) {
    console.warn('Navigation called before router was initialized');
    return;
  }
  if (typeof path === 'string') {
    appRouter.navigate(path, { replace: true, state });
  } else {
    appRouter.navigate(toPathString(path), {
      replace: true,
      state: path.state ?? state,
    });
  }
};

export const goBack = () => {
  if (!appRouter) {
    console.warn('Navigation called before router was initialized');
    return;
  }
  appRouter.navigate(-1);
};
